export const getFeatureInfoElementID = (featureName, sectionName, index) => {
  const featureNameParts = featureName.split("."); // feature name is something like "pricingPage.features.titles.whiteboard"
  let featureActualName = featureNameParts[featureNameParts.length - 1];
  if (featureName.endsWith(".alt")) {
    // some features have alternative texts in a test, so they get two keys, the second ending with ".alt"
    featureActualName = featureNameParts[featureNameParts.length - 2]; // one part before the "alt"
  }
  return `featureInfo_${featureActualName}_${sectionName}_${index}`; // adding 'index' on the offchance that the same feature appears twice in a section.
};
